import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { Avatar, Ratings, Button, PrimaryButton, IconCollection } from '../';

import css from './AboutOwner.module.css';
import classNames from 'classnames';

const BIO_MAX_LENGTH = 180;

function truncate(text, maxLength) {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
}

const AboutOwner = ({ profile, listingsCount, reviews, rating, verified, intl, variant, showOnlyReview = false, onClick = () => { }, storeLink = () => { } }) => {
    if (!profile) return null;
    const publicData = profile?.attributes?.profile?.publicData || {};
    const displayName = publicData.storeName || profile?.attributes?.profile?.displayName || '';
    const memberSince = profile?.attributes?.createdAt
        ? new Date(profile.attributes.createdAt).getFullYear()
        : '';
    const bio = profile?.attributes?.profile?.bio || '';
    const avatarUser = profile;
    const reviewCount = Array.isArray(reviews) ? reviews.length : 0;
    const listingsLabel = intl.formatMessage({ id: 'AboutOwner.listings' }, { count: listingsCount });
    const reviewsLabel = intl.formatMessage({ id: 'AboutOwner.reviews' }, { count: reviewCount });
    const verifiedLabel = intl.formatMessage({ id: 'AboutOwner.verified' });
    const messageOwnerLabel = intl.formatMessage({ id: 'AboutOwner.messageOwner' });
    const visitStoreLabel = intl.formatMessage({ id: 'AboutOwner.visitStore' });

    return (
        <>
            {showOnlyReview ?
                <div className={css.onlyReview}>
                    <div className={css.review}>
                        <Ratings rating={rating || 5} reviews={reviewCount} className={css.ratings} />
                        <span className={css.rating}>{rating ? rating.toFixed(1) : '5.0'}</span>
                        <span className={css.count}>({reviewCount} {reviewsLabel})</span>
                    </div>
                </div>
                :
                <div className={classNames(css.panel, variant === "sm" && css.panelSM)}>
                    <h4 className={css.heading}>
                        {variant === "sm" ? <FormattedMessage id="AboutOwner.storeOwner" defaultMessage="Store Owner" /> : <FormattedMessage id="AboutOwner.aboutTheOwner" defaultMessage="About The Owner" />}
                    </h4>
                    <div className={css.avatarWrapper}>
                        <Avatar user={avatarUser} renderSizes="48px" className={css.avatar} />
                        <div className={css.ownerRightContent}>
                            <div className={css.nameWithBadge}>
                                <span >{displayName}</span>
                                {verified && (
                                    <span className={css.badge}>
                                        <IconCollection name="profile_varified" />
                                        <span className={css.desktopLabel}>{verifiedLabel}</span></span>
                                )}
                            </div>
                            <div className={css.memberSince}>
                                <FormattedMessage id="AboutOwner.memberSince" defaultMessage="Member since {year}" values={{ year: memberSince }} />
                            </div>
                            <div className={css.review}>
                                <Ratings rating={rating || 5} reviews={reviewCount} className={css.ratings} />
                                <span className={css.rating}>{rating ? rating.toFixed(1) : '5.0'}</span>
                                <span className={css.count}>({reviewCount} {reviewsLabel})</span>

                                <span className={css.divider}></span>
                                <span className={css.listings}>{listingsCount} {listingsLabel}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ fontSize: 15, color: '#444', marginBottom: 16 }}>
                        {truncate(bio, BIO_MAX_LENGTH)}
                    </div>
                    <div className={css.buttonGroup}>
                        <Button variant="danger" arrow='left' onClick={onClick} icon={<i className="ri-message-3-line"></i>}>{messageOwnerLabel}</Button>
                        {storeLink ? storeLink :
                            <Button className={css.infoButton} variant="info" arrow='right' icon={<IconCollection name="arrow_righ_stright" />}>
                                {visitStoreLabel}</Button>}
                    </div>
                </div>
            }
        </>

    );
};

AboutOwner.propTypes = {
    profile: PropTypes.object,
    listingsCount: PropTypes.number,
    reviews: PropTypes.array,
    rating: PropTypes.number,
    verified: PropTypes.bool,
    intl: PropTypes.object.isRequired,
};

export default AboutOwner; 